class VariantPicker extends HTMLElement {
  connectedCallback() {
    this._variants = JSON.parse(this.dataset.variants || '[]');
    this.addEventListener('change', this._onChange.bind(this));
  }

  _onChange() {
    const variant = this._findSelectedVariant();
    if (!variant) return;
    this._updateVariantInput(variant);
    this._updateURL(variant);
    this._updatePrice(variant);
    this._updateButton(variant);
    this._updateMedia(variant);
  }

  _findSelectedVariant() {
    const selectedOptions = Array.from(this.querySelectorAll('[data-option-index]'))
      .filter((el) => el.checked)
      .map((el) => ({ index: parseInt(el.dataset.optionIndex), value: el.value }));
    return this._variants.find((v) =>
      selectedOptions.every(({ index, value }) => v.options[index] === value)
    );
  }

  _updateVariantInput(variant) {
    const input = document.getElementById('variant-id');
    if (input) input.value = variant.id;
  }

  _updateURL(variant) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
  }

  _updatePrice(variant) {
    const el = document.getElementById('product-price');
    if (!el) return;
    const fmt = (cents) => {
      const str = window.slapNails?.moneyFormat || '${{amount}}';
      return str
        .replace('{{amount}}', (cents / 100).toFixed(2))
        .replace('{{amount_no_decimals}}', Math.floor(cents / 100));
    };
    const { price, compare_at_price: compareAt } = variant;
    if (compareAt && compareAt > price) {
      el.innerHTML = `<div class="flex items-center gap-2">
        <span class="font-display font-bold text-xl text-primary">${fmt(price)}</span>
        <span class="font-body text-base text-on-surface-variant line-through">${fmt(compareAt)}</span>
      </div>`;
    } else {
      el.innerHTML = `<div class="flex items-center gap-2">
        <span class="font-display font-bold text-xl text-on-surface">${fmt(price)}</span>
      </div>`;
    }
  }

  _updateButton(variant) {
    const btn = document.getElementById('add-to-cart-btn');
    if (!btn) return;
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? 'Snag It' : 'Sold Out';
  }

  _updateMedia(variant) {
    if (!variant.featured_media?.preview_image?.src) return;
    const img = document.getElementById('product-featured-image');
    if (img) {
      img.src = variant.featured_media.preview_image.src;
      img.alt = variant.featured_media.alt || '';
    }
  }
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.querySelector('form')?.addEventListener('submit', this._onSubmit.bind(this));
  }

  async _onSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)),
    });

    if (res.ok) {
      document.dispatchEvent(new CustomEvent('cart:open'));
      const drawer = document.querySelector('cart-drawer');
      await drawer?._rerender();
      await drawer?._syncCartCount();
    } else {
      const data = await res.json();
      alert(data.description || 'Could not add to cart.');
    }

    if (btn) { btn.disabled = false; btn.textContent = 'Snag It'; }
  }
}

customElements.define('variant-picker', VariantPicker);
customElements.define('product-form', ProductForm);
